import axios from "axios";
import axiosRetry from "axios-retry";
import { loadDashToken } from "./authService";
import { axiosConfig } from "../configs/axiosConfig";

export function getDashConfig() {
	if (axiosConfig.headers.authorization === null) {
		setJwt(loadDashToken());
	}

	return axiosConfig;
}

export function setJwt(jwt) {
	axiosConfig.headers.authorization = `Bearer ${jwt}`;
}

axiosRetry(axios, {
	retryDelay: (retryCount) => {
		return retryCount * 1000; // time interval between retries
	},
	// onRetry: (retryCount, error, requestConfig) => {
	// 	console.log("OnRetry", retryCount, error, requestConfig);
	// },
	retryCondition: (error) => {
		let retry = false;
		if (error?.message && error.message.toLowerCase() === "network error") {
			retry = true;
		} else if (
			error?.response?.status &&
			error.response.status >= 503 &&
			error.response.status <= 504
		) {
			retry = true;
		}

		return retry;
	},
});

const def = {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete,
};

export default def;
